import { push, replace } from 'connected-react-router';
import { call, CallEffect, put, PutEffect } from 'redux-saga/effects';

import { AddScribeAction, addScribeSuccess } from 'js/actionCreators/scribeActions';
import { hideModal, showError } from 'js/actionCreators/uiActions';
import { PIN_ALL_CAMERA_BY_DEFAULT } from 'js/config/config';
import { sendErrorToSentry } from 'js/logging';
import ScribeModel from 'js/models/ScribeModel';
import { createProject } from 'js/shared/helpers/app-services/AppServices/projects';
import { getScribeLink } from 'js/shared/helpers/linkHelper';
import { ExistingScribeModel } from 'js/types';

export function* addProject(action: AddScribeAction): Generator<CallEffect | PutEffect, void, ExistingScribeModel> {
  try {
    const model = new ScribeModel({
      title: action.title,
      canvasSize: action.canvasSize,
      createdOn: action.date,
      updatedOn: action.date,
      source: action.source,
      rawElements: action.elements,
      thumbnailImage: action.thumbnail,
      settings: action.settings,
      scenes: action.scenes,
      audioClips: action.audioClips,
      pinAllCameras: PIN_ALL_CAMERA_BY_DEFAULT,
      projectAudioLayerIds: action.projectAudioLayerIds
    });

    const scribe = yield call(createProject, model);

    yield put(addScribeSuccess(scribe));
    yield put(hideModal(scribe.id));

    if (action.replaceHistory) {
      yield put(replace(getScribeLink(scribe)));
    } else {
      yield put(push(getScribeLink(scribe)));
    }
  } catch (error) {
    sendErrorToSentry(error as Error);
    yield put(showError(error as Error));
  }
}
